// extracted by mini-css-extract-plugin
module.exports = {"scoreLine":"e__qb","scoreRing":"e_0qb","badge":"e_1qb","badgeImage":"e_2qb","spaced":"e_3qb"};